import styled from "styled-components";

export const LotteryContent = styled.div`
  width: 100%;
`;

export const ComparisonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 28px;
  max-width: 1040px;
  margin: 0 auto;
  align-items: stretch;

  @media screen and (max-width: 820px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;

export const ComparisonCard = styled.div`
  background: #ffffff;
  border-radius: 18px;
  border: 1.5px solid #e5eaf5;
  box-shadow: 0 6px 24px rgba(12, 21, 56, 0.05);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 14px 32px rgba(12, 21, 56, 0.1);
  }

  &.before-card {
    border-color: #f0d5d5;
    &:hover {
      border-color: #e21b22;
    }
  }

  &.after-card {
    border-color: rgba(40, 6, 249, 0.3);
    box-shadow: 0 8px 28px rgba(40, 6, 249, 0.08);

    &:hover {
      border-color: #2806f9;
      box-shadow: 0 16px 36px rgba(40, 6, 249, 0.16);
    }
  }

  .card-badge {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;

    &.before-badge {
      background: #fff0f0;
      color: #c91818;
      border-bottom: 1px solid #fedcdc;
    }

    &.after-badge {
      background: linear-gradient(135deg, #2806f9 0%, #4f2eff 100%);
      color: #ffffff;
      box-shadow: 0 4px 12px rgba(40, 6, 249, 0.25);
    }
  }

  .img-frame {
    width: 100%;
    overflow: hidden;
    background: #f0f4fa;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: auto;
      display: block;
      transition: transform 0.4s ease;
    }

    &:hover img {
      transform: scale(1.02);
    }
  }

  .card-points {
    padding: 20px 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    background: #ffffff;
    flex-grow: 1;

    .point-item {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      font-size: 14px;
      line-height: 1.45;

      .icon {
        flex-shrink: 0;
        margin-top: 3px;
        font-size: 14px;
      }

      &.negative {
        color: #616e88;
        .icon {
          color: #d12e2e;
        }
      }

      &.positive {
        color: #0c1538;
        font-weight: 600;
        .icon {
          color: #2806f9;
        }
      }
    }
  }
`;
